import { ReactNode } from 'react';

import { Box } from '@aicon-dev/caas-core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ReportIconEmpty } from './ReportList.icons';

export interface ReportListEmptyProps {
  icon?: ReactNode;
  text?: ReactNode;
}

export const ReportListEmpty = (props: ReportListEmptyProps) => {
  const { icon, text } = props;
  const { t } = useTranslation('report');

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="203px"
      background="#F5F5F5"
    >
      <IconWrap>{icon || <ReportIconEmpty />}</IconWrap>
      <Box color="#666666" fontSize={14} fontWeight={400}>
        {text || t('report:there_is_no_work_reported')}
      </Box>
    </Box>
  );
};

const IconWrap = styled.div`
  display: flex;
  color: #c4c4c4;
  font-size: 40px;
  margin-bottom: 14px;
`;
